import { Currency } from '../../constants/currency';
import type { Condition } from '../../hooks/useProductData';
import { getAmountRangeToString } from '../humanization';

export const getSavingsConditions = (item): Condition[] => {
  const conditions: Condition[] = [];
  const { term, rate, amount } = item;

  const amountValue = getAmountRangeToString({ amountRange: amount, currency: Currency.RUB });

  conditions.push({ value: rate, description: 'Cтавка в год' });
  conditions.push({ value: amountValue, description: 'Сумма вклада' });
  conditions.push({ value: term, description: 'Срок' });

  return conditions;
};
